module.exports = __webpack_public_path__ + "static/media/8.cfaa7c65.JPG";